import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'connect-replication-detail-datapicker',
  templateUrl: 'connect-replication-detail-datapicker.component.html',
  styleUrls: ['connect-replication-detail-datapicker.component.scss']
})
export class ConnectReplicationDetailDatapickerComponent implements OnInit, OnChanges {

  public recurrence: any = {};
  @Input() typeRecurrence: string = '';
  @Input() valueRecurrence: string = '';

  @Input() enableditem: boolean = true;

  @Output() valueInput = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.typeRecurrence || this.valueRecurrence)
      this.changeLimits();
  }

  changeLimits() {
    this.recurrence.limitMinFrequency = 1;
    if (this.typeRecurrence === 'Daily'){
      this.recurrence.limitMaxFrequency = 999;
      this.recurrence.limitLength = 3;
    }
    if (this.typeRecurrence === 'Weekly') {
      this.recurrence.limitMaxFrequency = 100;
      this.recurrence.limitLength = 3;
    }
    if (this.typeRecurrence === 'Monthly') {
      this.recurrence.limitMaxFrequency = 12;
      this.recurrence.limitLength = 2;
    }
    if (this.typeRecurrence === 'Month') {
      this.recurrence.limitMaxFrequency = 31;
      this.recurrence.limitLength = 2;
    }
    if (this.typeRecurrence === 'Minutes') {
      this.recurrence.limitMaxFrequency = 59;
      this.recurrence.limitLength = 2;
    }
    if (this.typeRecurrence === 'Hours') {
      this.recurrence.limitMaxFrequency = 23;
      this.recurrence.limitLength = 2;
    }
    if (this.typeRecurrence === 'Date_minutes') {
      this.recurrence.limitMinFrequency = 0;
      this.recurrence.limitMaxFrequency = 59;
      this.recurrence.limitLength = 2;
    }
    if (this.typeRecurrence === 'Date_hours') {
      this.recurrence.limitMinFrequency = 0;
      this.recurrence.limitMaxFrequency = 23;
      this.recurrence.limitLength = 2;
    }
    this.validateValues();
  }

  validateValues() {
    if (this.valueRecurrence > this.recurrence.limitMaxFrequency)
      this.recurrence.frequency = this.recurrence.limitMaxFrequency;
    else if (this.valueRecurrence < this.recurrence.limitMinFrequency)
      this.recurrence.frequency = this.recurrence.limitMinFrequency;
    else
      this.recurrence.frequency = this.valueRecurrence;
    this.valueInput.emit(this.recurrence.frequency);
  }

  allowedValues() {
    if (this.recurrence.frequency) {
      this.recurrence.frequency = parseInt(this.recurrence.frequency, 10);
      if (this.recurrence.frequency.toString().length > this.recurrence.limitLength || this.recurrence.frequency > this.recurrence.limitMaxFrequency)
        this.recurrence.frequency = this.recurrence.limitMaxFrequency;
      this.valueInput.emit(this.recurrence.frequency);
    }
  }

  minFrequency() {
    this.recurrence.frequency--;
    if (this.recurrence.frequency === (this.recurrence.limitMinFrequency - 1))
      this.recurrence.frequency = this.recurrence.limitMaxFrequency;
    this.concatNumber();
    this.valueInput.emit(this.recurrence.frequency);
  }

  maxFrequency() {
    this.recurrence.frequency++;
    if (this.recurrence.frequency === (this.recurrence.limitMaxFrequency + 1))
      this.recurrence.frequency = this.recurrence.limitMinFrequency;
    this.concatNumber();
    this.valueInput.emit(this.recurrence.frequency);
  }

  valueNull() {
    this.allowedValues();
    if (!this.recurrence.frequency) {
      this.recurrence.frequency = this.recurrence.limitMinFrequency;
      this.concatNumber();
      this.valueInput.emit(this.recurrence.frequency);
    }
  }

  concatNumber() {
    if ((this.typeRecurrence === 'Date_hours' || this.typeRecurrence === 'Date_minutes') && this.recurrence.frequency < 10)
      this.recurrence.frequency = '0' + this.recurrence.frequency;
  }
}
